<template>
  <div class="container">
    <div class="headerer">
      <Mheader @changeTab="changeTab"></Mheader>
    </div>
    <div class="content">
      <IndexContent v-show="currentTab==1"></IndexContent>
      <SmartClass v-show="currentTab==2"></SmartClass>
      <Service v-show="currentTab==3"></Service>
      <ForUs v-show="currentTab==4"></ForUs>
    </div>
    <div class="footer">
      <div>公司地址：安徽省合肥市高新区望江西路666号A5-13F</div>
      <div>邮编：230088 联系电话：0551-65309504 电子信箱：xxli8@iflytek.com</div>
      <div>版权所有 安徽讯飞皆成软件技术有限公司 网站备案编号：<span class="link" @click="jump">皖B2-20170006号</span></div>
    </div>
  </div>
</template>

<script>
import Mheader from './header'
import IndexContent from './index-content'
import SmartClass from './smart-class'
import Service from './service'
import ForUs from './for-us2'
export default {
  name: 'index',
  components:{
    Mheader,
    IndexContent,
    SmartClass,
    Service,
    ForUs
  },
  data () {
    return {
      currentTab:1
    }
  },
  methods:{
    changeTab(index){
      this.currentTab=index
    },
    jump(){
      window.open("http://www.beian.miit.gov.cn/");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.link{
  cursor: pointer;
  color: #009dee;
}
.container{
  width: 100%;
  background: white;
}
.header{
  width: 100%;
  height: 80px;
}
.content{
  width: 100%;
}
.footer{
  width: 100%;
  height:105px;
  background:#444444;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size:14px;
  font-weight:400;
  color:#888888;
  line-height:31px;
  font-family:MicrosoftYaHei;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue